import { Component, Inject} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ProfileService} from "../services/profile.service";
import {ErrorMessageProvider} from "../providers/error.message.provider";


@Component({
    selector: 'app-password-confirmation',
    templateUrl: './password.confirmation.html',
})
export class PasswordConfirmationComponent {

    form: FormGroup;

    constructor(
        private profileService: ProfileService,
        private errMsgProvider: ErrorMessageProvider,
        private fb: FormBuilder,
        public dialogRef: MatDialogRef<PasswordConfirmationComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.form = this.fb.group({
            password: [null],
        });
    }

    confirm(){
        this.profileService.confirmIdentity(this.form.value).subscribe(res => {
            if(res.success){
                this.dialogRef.close( true );
            }else{
                this.errMsgProvider.show('Contraseña inválida');
            }
        });
    }

    cancel(){
        this.dialogRef.close(false);
    }

}


// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/shared/modules/password.confirmation.ts